/**
 * @file
 * Custom JS for the Success stories page's exposed filters.
 */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Restructure the search filter.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.storiesCardFilter = {
    attach: function (context) {
      const container = $(
        '.success-stories__filter form',
        context
      );
      const personaField = container
        .find('.js-form-type-select.form-item-persona');
      const collegeField = container
        .find('.js-form-type-select.form-item-college');
      const departmentField = container
        .find('.js-form-type-select.form-item-department');
      const programField = container
        .find('.js-form-type-select.form-item-program');
      const buttonField = container
        .find('.form-actions.js-form-wrapper');
      const formFieldsContainer =
        $('<div class="success-stories-filter-inputs"></div>')
          .append(personaField)
          .append(collegeField)
          .append(departmentField)
          .append(programField);
      const btnContainer =
        $('<div class="success-stories-filter-buttons"></div>')
          .append(buttonField);
      container.append(formFieldsContainer)
        .append(btnContainer);
    }
  };
})(document, Drupal, jQuery);
